module.exports = __webpack_public_path__ + "static/img/kj1-3.464fb57.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/kj1-3.png
// module id = 919
// module chunks = 0